import { render, staticRenderFns } from "./RoundCheckbox.vue?vue&type=template&id=63394eda&"
import script from "./RoundCheckbox.vue?vue&type=script&lang=ts&"
export * from "./RoundCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./RoundCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports